import * as React from 'react';
import { Stack, Paper, Button, InputBase } from "@mui/material";

const CheckinInput = (props) => {
    var txt = '';
    if (props.text) {
        txt = props.text;
    }

    const [inputActive, setInputActive] = React.useState(false);
    const [textValue, setTextValue] = React.useState(txt);
    const [requiredData, setRequiredData] = React.useState(false);

    

    const handleTextChange = (event) => {
        const text = event.target.value;
        setTextValue(text);
        setRequiredData(text.trim().length > 0);

        if (props.onChange) {
            props.onChange(text);
        }
    }

    return (
        <Paper
            elevation={0}
            sx={{
                padding: 1.5,
                paddingLeft: 3,
                // paddingBottom: 2,
                // paddingRight: 3,
                borderRadius: 2.5,
                border: '1px solid #F0ECF0',
                background: inputActive ? "white" : "#FAF6FA",
                transition: "all .5s ease",
                WebkitTransition: "all .5s ease",
                MozTransition: "all .5s ease",
            }}

        >
            <Stack direction="column" spacing={1}>
                <Stack direction="row" spacing={1}>
                    <InputBase
                        multiline
                        onFocus={() => setInputActive(true)}
                        onBlur={() => setInputActive(false)}
                        placeholder={props.placeholder}
                        fullWidth
                        value={textValue}
                        onChange={handleTextChange}
                    />
                    {props.button &&
                        <Button
                            disabled={props.buttonDisabled | !requiredData}
                            variant="contained"
                            style={{ backgroundColor: (props.buttonDisabled | !requiredData) ? "#fffbff" : "#3f0300", maxHeight: "40px", borderRadius: "20px", width: "20px" }}
                            onClick={props.buttonAction}
                        >
                            {
                                props.buttonIcon
                            }
                        </Button>
                    }
                </Stack>
            </Stack>
        </Paper>
    )
}

export { CheckinInput };